import { cn } from '@/lib/utils'

export function AuthCard({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'relative z-10 w-full max-w-[400px] rounded-card border border-border-2 bg-card p-10 shadow-modal',
        className,
      )}
    >
      {children}
    </div>
  )
}
